import { createTheme, Theme } from '@mui/material/styles';

export const theme: Theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
    },
});
